import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import { Avatar } from "./Avatar";
import { type AvatarDataProps, avatarDataSchema } from "./Avatar.schema";
import { AVATAR_TAG_NAME } from "./constants";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    [AVATAR_TAG_NAME]: { props: AvatarDataProps; handle: undefined };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-avatar": HTMLElement;
  }
}

function RWCAvatar({
  url,
  size,
  variant,
  kind,
  bordered,
  invalid,
  success,
  status,
  fallback,
}: AvatarDataProps): JSX.Element {
  return (
    <Avatar
      url={url}
      size={size}
      variant={variant}
      kind={kind}
      bordered={bordered}
      invalid={invalid}
      success={success}
      status={status}
      fallback={fallback}
    />
  );
}

componentManager.register(
  rwc(AVATAR_TAG_NAME, {
    component: RWCAvatar,
    dataSchema: avatarDataSchema,
  }),
);
